// 'use client';

// import Image from 'next/image';
// import { useState } from 'react';
// import { ChevronDown } from 'lucide-react';
// import Title from "../Title";
// import RichTextRenderer from "@/ui/Richtextrender";
// import { buildFaqSchema, stringifyJsonLd } from "@/utils/faqSchema";
// const FAQSection = ({ data }) => {
//   const [openIndex, setOpenIndex] = useState(0);

//     const faqsFromData =
//     data?.attributes?.Faq_tab ||
//     data?.Faq_tab ||
//     data?.attributes?.Faqs?.Faq_tab ||
//     data?.attributes?.Faqs?.data?.attributes?.Faq_tab ||
//     data?.Faqs?.Faq_tab ||
//     data?.Faqs?.data?.attributes?.Faq_tab ||
//     [];

//   const toggleAccordion = (index) => {
//     setOpenIndex(index);
//   };
// // Normalize Strapi FAQ items to standard format
//   const normalizeFaq = (item) => {
//     if (!item) return null;
//     const q = item?.Title || item?.title || item?.question || item?.attributes?.Title || item?.attributes?.title;
//     let a = item?.Content || item?.content || item?.answer || item?.attributes?.Content || item?.attributes?.content;
//     return { question: q || '', answer: a ?? '' };
//   };

//   // Use Strapi data if available, otherwise use defaults
//   let faqs = [];
//   if (faqsFromData && faqsFromData.length > 0) {
//     faqs = faqsFromData.map(normalizeFaq).filter(Boolean);
//     if (faqs.length === 0) faqs = defaultFaqs;
//   }
//   return (
//     <section className="max-w-[var(--max-page-width)] mx-auto px-[var(--container-padding)] pb-24">
//          <div className="w-full heading_space_bottom">
//            <Title
//             heading={"Frequently Asked Questions"}
//             subText={`Find answers to your most common questions and discover more about our programs and services.`}
//             color="text-black"
//             subTextColor="text-black/70"
//             align="text-left"
//           />
//         </div>
//       <div className="flex flex-col md:flex-row items-center justify-between gap-12">
//         <div className="w-full md:w-1/2 mb-8 md:mb-0">
         
//           <div className="">
//             {faqs.map((faq, index) => (
//               <div key={index} className={`border-l-4 pl-4 py-2 transition-colors duration-500 ease-in-out ${openIndex === index ? 'border-[#0475B3]' : 'border-gray-200'}`}>
//                 <div className="border-b-2 border-gray-200 pb-4">
//                      <button
//                   onClick={() => toggleAccordion(index)}
//                   className="w-full flex items-center justify-between hover:opacity-80 transition-all duration-300 ease-in-out cursor-pointer group"
//                 >
//                   <h3 className={`text-base font-semibold text-left transition-colors duration-500 ease-in-out ${openIndex === index ? 'text-[#0475B3]' : 'text-black'}`}>{faq.question}</h3>
                  
//                 </button>
//                 <div
//                   className={`overflow-hidden transition-all duration-1500  ${
//                     openIndex === index ? 'max-h-96' : 'max-h-0'
//                   }`}
//                 >
//                   <p className="pt-3 pb-2 text-sm text-gray-700 leading-relaxed">
//                     {faq.answer}
//                   </p>
//                 </div>
               
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//         <div className="w-full md:w-1/2">
//           <Image 
//             src="/home/faq.png" 
//             alt="FAQ Image"
//             width={680}
//             height={680}
//           />
//         </div>
//       </div>
//     </section>
//   );
// };

// export default FAQSection;

'use client';

import Image from 'next/image';
import { useState } from 'react';
import Title from "../Title";
import RichTextRenderer from "@/ui/Richtextrender";
import { buildFaqSchema, stringifyJsonLd } from "@/utils/faqSchema";

const FAQSection = ({ data }) => {
  const [openIndex, setOpenIndex] = useState(0);

  // Extract FAQs from Strapi data, including nested relation shapes
  const faqsFromData =
    data?.attributes?.Faq_tab ||
    data?.Faq_tab ||
    data?.attributes?.Faqs?.Faq_tab ||
    data?.attributes?.Faqs?.data?.attributes?.Faq_tab ||
    data?.Faqs?.Faq_tab ||
    data?.Faqs?.data?.attributes?.Faq_tab ||
    [];

  const defaultFaqs = [
    {
      "question": "What is Medhavi Skills University?",
      "answer": "<strong>Medhavi Skills University (MSU)</strong> is a private skill-based university located in <strong>Sikkim, India</strong>. Established under the <strong>Sikkim Act, 2021</strong> and recognised by the <strong>UGC under Section 2(f)</strong>, the university offers industry-led, skill-integrated programmes focused on employability. MSU emphasises work-integrated learning, industry partnerships and job-ready education. Aligned with NEP 2020, the university follows an <strong>Outcome-Based Education</strong> framework with competency-driven curricula, industry training, and technology-enabled learning to prepare students for modern careers."
    },
    {
      "question": "What programs does MSU offer?",
      "answer": "MSU offers Diploma, Undergraduate and Postgraduate programs across multiple disciplines such as:<ul class='list-disc ml-5 mt-2 space-y-2'><li><strong>Health Science & Technology</strong></li><li><strong>Computer Science & Engineering</strong></li><li><strong>Hospitality & Tourism</strong></li><li><strong>Pharmacy</strong></li><li><strong>Management & Commerce</strong></li><li><strong>Nursing</strong></li><li><strong>Humanities</strong></li></ul>All programmes combine academic learning with practical industry exposure, with 70% practical learning, paid on-the-job training, and 100% placement assistance."
    },
    {
      "question": "How is MSU different from traditional universities?",
      "answer": "MSU follows a skill-integrated education model where academic learning is combined with real industry experience, with <strong>70% practical learning</strong>.<br/><br/>Key differences include:<ul class='list-disc ml-5 mt-2 space-y-2'><li><strong>On-the-Job Learning (OJL)</strong> integrated into the curriculum</li><li><strong>Industry experts</strong> as mentors and real workplace exposure</li><li><strong>16+ advanced labs</strong> across departments and skill drills before workplace training</li><li><strong>Industry-aligned curriculum</strong> focused on employability</li></ul><br/>Instead of focusing only on theory, MSU aims to build <strong>career-ready professionals with practical skills and work experience</strong>."
    },
    {
      "question": "Is Medhavi Skills University recognised by the UGC?",
      "answer": "Yes. <strong>Medhavi Skills University</strong> is recognised by the <strong>University Grants Commission (UGC) under Section 2(f)</strong>.<br/><br/>This means that the degrees issued by MSU are <strong>valid across India for employment, higher studies, and government jobs</strong>, at par with any other recognised university."
    },
    {
      "question": "What is the admission process?",
      "answer": "The admission process at MSU is primarily online and involves:<ul class='list-disc ml-5 mt-2 space-y-2'><li>Submission of the online application form.</li><li>Appearing for the <strong>Medhavi Scholarship & Aptitude Test (MSAT)</strong>.</li><li>Receiving an admission offer based on merit and test scores.</li><li>Document verification and fee payment to secure admission.</li></ul>"
    },
    {
      "question": "Does MSU provide scholarships?",
      "answer": "Yes, MSU provides various scholarships including <strong>MSAT-based scholarships, Merit-based scholarships</strong> (based on Class 12 marks), and support for <strong>Government Scholarship</strong> schemes, particularly for students from the North Eastern Region."
    },
    {
      "question": "Are internships and jobs guaranteed?",
      "answer": "MSU provides <strong>100% placement assistance</strong> and focuses on employability through its <strong>Work Integrated Skill-based Higher Education (WISE)</strong> model. Students gain significant real-world exposure and practical skills, making them highly desirable to top employers."
    },
    {
      "question": "Where are MSU's campuses located?",
      "answer": "MSU's main campus is located in <strong>Bermiok, West Sikkim</strong>. The university also has established various skill training centers and industry-integrated labs across the region to facilitate hands-on learning."
    },
    {
      "question": "How can I apply for admission?",
      "answer": "You can apply directly through the <strong>official MSU website</strong> by filling out the online registration form and following the step-by-step instructions provided in the admission portal."
    },
    {
      "question": "Where can I find official contact details?",
      "answer": "Official contact details, including email addresses and phone numbers for admissions and general inquiries, can be found on the <strong>'Contact Us'</strong> page of our official website."
    }
  ];

  const toggleAccordion = (index) => {
    setOpenIndex(index);
  };

  // Normalize Strapi FAQ items to standard format
  const normalizeFaq = (item) => {
    if (!item) return null;
    const q = item?.Title || item?.title || item?.question || item?.attributes?.Title || item?.attributes?.title;
    let a = item?.Content || item?.content || item?.answer || item?.attributes?.Content || item?.attributes?.content;
    return { question: q || '', answer: a ?? '' };
  };

  // Use Strapi data if available, otherwise use defaults
  let faqs = defaultFaqs;
  if (faqsFromData && faqsFromData.length > 0) {
    faqs = faqsFromData.map(normalizeFaq).filter(Boolean);
    if (faqs.length === 0) faqs = defaultFaqs;
  }

  const faqSchema = buildFaqSchema(faqs);

  return (
    <section className="max-w-[var(--max-page-width)] mx-auto px-[var(--container-padding)] pb-24">
      <script
        id="FAQSchema"
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: stringifyJsonLd(faqSchema) }}
      />
      <div className="w-full heading_space_bottom">
        <Title
          heading={"Frequently Asked Questions"}
          subText={`Find answers to your most common questions and discover more about our programs and services.`}
          color="text-black"
          subTextColor="text-black/70"
          align="text-left"
        />
      </div>
      <div className="flex flex-col md:flex-row items-center justify-between gap-12">
        <div className="w-full md:w-1/2 mb-8 md:mb-0 h-[556px] overflow-auto [scrollbar-width:thin] ![scrollbar-color:#d1d5db_#f3f4f6] [&::-webkit-scrollbar-thumb]:!bg-[#d1d5db] [&::-webkit-scrollbar-track]:!bg-[#f3f4f6] [&::-webkit-scrollbar]:w-1.5">

          <div className="">
            {faqs.map((faq, index) => {
              const question = faq?.question || faq?.title || faq?.Title || '';
              const answer = faq?.answer || faq?.content || faq?.Content || '';
              return (
                <div key={index} className={`border-l-4 pl-4 py-2 transition-colors duration-500 ease-in-out ${openIndex === index ? 'border-[#0475B3]' : 'border-gray-200'}`}>
                  <div className="border-b-2 border-gray-200 pb-4">
                    <button
                      onClick={() => toggleAccordion(index)}
                      className="w-full flex items-center justify-between hover:opacity-80 transition-all duration-300 ease-in-out cursor-pointer group"
                    >
                      <h3 className={`text-base font-semibold text-left transition-colors duration-500 ease-in-out ${openIndex === index ? 'text-[#0475B3]' : 'text-black'}`}>{question}</h3>
                    </button>
                    <div
                      className={`overflow-hidden transition-all duration-500 ease-in-out ${openIndex === index ? 'max-h-[1000px]' : 'max-h-0'
                        }`}
                    >
                      <div className="pt-3 pb-2 text-sm text-gray-700 leading-relaxed prose prose-sm max-w-none">
                        {Array.isArray(answer) ? (
                          <RichTextRenderer content={answer} />
                        ) : (
                          <div dangerouslySetInnerHTML={{ __html: answer }} />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
        <div className="w-full md:w-1/2">
          <Image
            src="/home/faq.png"
            alt="FAQ Image"
            width={680}
            height={680}
          />
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
